import { render, staticRenderFns } from "./EditSalaryComponent.vue?vue&type=template&id=5e5a71ab&scoped=true"
import script from "./EditSalaryComponent.vue?vue&type=script&lang=js"
export * from "./EditSalaryComponent.vue?vue&type=script&lang=js"
import style0 from "./EditSalaryComponent.vue?vue&type=style&index=0&id=5e5a71ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a71ab",
  null
  
)

export default component.exports